import TableContainer from "@/components/_table-container";
import CreateCowModal from "@/components/_modals/create-cow";
import HeatReportModal from "@/components/_modals/heat-report";
import PasswordCheckModal from "@/components/_modals/password-check";
import UtilsService from '@/services/UtilsService'
import CowsService from "../../services/CowsService";
import { RoleTypes } from "@/constants/role_types";

import { mapState, mapActions } from "vuex";

export default {
  name: "NewCows",
  components: { TableContainer, CreateCowModal, HeatReportModal, PasswordCheckModal },
  data() {
    return {
      utilsService: UtilsService,
      error: null,
      loading: null,
      createCowModalVisible: false,
      heatReportModalVisible: false,
      passwordCheckModalVisible: false,
      correctPassword: false,
      searchText: "",
      cowsCsv: null,
      cowsPerPage: 100,
      page: 1,
      totalPages: 1,
      sortBy: {
        key: undefined,
        direction: undefined
      },
      generateHeatReport: {
        isInProgress: false,
        cows: [],
        fromDate: null,
        toDate: null
      },
      editTags: {
        isInProgress: false,
        selectedTags: [],
      },
      selected: [],
      selectAll: false,
      headers: [
        {
          sortByKey: "eartag",
          text: this.$t("cowGenerics.eartag")
        },
        {
          sortByKey: "breed",
          text: this.$t("cowDetails.breed")
        },
        {
          sortByKey: "lactation_number",
          text: this.$t("cowDetails.lactationNumber")
        },
        {
          sortByKey: "birth_date",
          text: this.$t("cowGenerics.birthDate")
        },
        {
          sortByKey: "last_calving",
          text: this.$t("cowGenerics.lastCalving")
        },
        {
          sortByKey: "last_insemination",
          text: this.$t("cowGenerics.lastInsemination")
        },
        {
          sortByKey: "building_name",
          text: this.$t("buildingGenerics.building")
        },
        {
          sortByKey: "bolus_name",
          text: this.$t("bolusGenerics.bolusName")
        },
        {
          sortByKey: "daysInMilk",
          text: this.$t("dashboardView.listHeader.daysInMilk")
        },
        {
          sortByKey: "daysInInsemination",
          text: this.$t("dashboardView.listHeader.daysInInsemination")
        },
        {
          sortByKey: "database_entry_time",
          text: this.$t("dashboardView.listHeader.lastSeen")
        },
        {
          sortByKey: "heat_index_raw",
          text: this.$t("dashboardView.listHeader.heatIndex")
        },
        {
          sortByKey: "pending_msg",
          text: this.$t("dashboardView.listHeader.pendingMsgs")
        },
        {
          sortByKey: "avg_48_h",
          text: this.$t("dashboardView.listHeader.avg48H")
        },
        {
          sortByKey: "highest_48_h",
          text: this.$t("dashboardView.listHeader.highest48H")
        },
        {
          sortByKey: "tags",
          text: this.$t("dashboardView.listHeader.tags")
        }
      ],
      RoleTypes: RoleTypes,
      showArchived: false
    };
  },
  mounted() {
    this.getTags();
    this.fetchCows();
  },
  destroyed() {
    // this.clearCows();
  },
  methods: {
    async fetchCows() {
      this.getCows({ with_building: true, with_bolus: true, with_heat_index: true, include_archived: true });
      this.getLatestSensorLogs();
      this.getTagsWithCow();
      this.getHighTempInfo();
    },
    async fileSelectOnChange(event) {
      this.cowsCsv = event.target.files ? event.target.files[0] : null;

      const cowsJson = await UtilsService.convertCsvToJson(this.cowsCsv);

      const response = await CowsService.uploadCows(cowsJson);

      if (response.status == 200){
        alert(response.data.message);
        this.fetchCows();
      }else{
        alert(response.data);
      }

      document.getElementById("fileUpload").value = "";
    },
    chooseFiles() {
      // alert(`Error in uploading cow "test_cow_1": Last insemination should be earlier then last calving \nError in uploading cow "test_cow_2": Please add lactation number that is greater then or equal to 0`)
      document.getElementById("fileUpload").click()
    },
    ...mapActions("cows", {
      getCows: "getCows",
      getHighTempInfo: "getHighTempInfo",
      setCowList: "setCowList",
      getTags: "getTags",
      getTagsWithCow: "getTagsWithCow",
      assignTags: "assignTags",
      clearTags: "clearTags",
      // clearCows: "clearCows"
    }),
    ...mapActions("sensorLogs", {
      getLatestSensorLogs: "getLatestSensorLogs"
    }),
    onSave(correctPassword) {
      // Update the correctPassword state
      this.correctPassword = correctPassword;

      if (this.correctPassword) {
        this.generateHeatReport.isInProgress = true
      }
      // Close the modal
      this.passwordCheckModalVisible = false;
    },
    getLastSeen(dateString) {
      if (!dateString) {
        return this.$t("general.never").toUpperCase();
      }

      const dateTime = this.$moment(dateString);

      const now = this.$moment();

      const diff = now - dateTime;

      const diffInDays = Math.ceil(diff / 1000 / 60 / 60 / 24);

      if (diffInDays === 1) {
        const diffInHours = Math.ceil(diff / 1000 / 60 / 60);
        if (diffInHours === 1) {
          const diffInMinutes = Math.ceil(diff / 1000 / 60);
          return `${diffInMinutes} minutes ago`;
        }
        return `${diffInHours} hours ago`;
      }

      return `${diffInDays} days ago`;
    },
    searchData(searchText, cows) {
      if (!searchText || searchText === "") {
        return cows;
      }
      const searchedData = [];
      cows.forEach(cow => {
        const cow_data = {
          ...cow, bolus_name: cow.bolus && cow.bolus.bolus_name, building_name: cow.building && cow.building.building_name,
          ...((cow.tags || []).map(({ name }) => '#' + name))
        };

        if (
          Object.values(cow_data).some(
            item =>
              item &&
              (item
                .toString()
                .toLowerCase()
                .includes(searchText.toLowerCase())
              )
          )
        ) {
          searchedData.push(cow);
        }
      });
      return searchedData;
    },
    sortData(cows) {
      // Sort by key
      return cows.sort((a, b) => {
        // Get nested values
        if (['database_entry_time', 'pending_msg'].includes(this.sortBy.key)) {
          a = (a.latest_sensor_log) ? a.latest_sensor_log : null;
          b = (b.latest_sensor_log) ? b.latest_sensor_log : null;
        }

        if (['building_name'].includes(this.sortBy.key)) {
          a = (a.building) ? a.building : null;
          b = (b.building) ? b.building : null;
        }

        if (['bolus_name'].includes(this.sortBy.key)) {
          a = (a.bolus) ? a.bolus : null;
          b = (b.bolus) ? b.bolus : null;
        }

        // Get values by keys
        let aKey, bKey;
        aKey = a ? a[this.sortBy.key] : null;
        bKey = b ? b[this.sortBy.key] : null;

        if (['birth_date', 'last_calving', 'last_insemination', 'database_entry_time', 'daysInMilk', 'daysInInsemination'].includes(this.sortBy.key)) {
          // Convert dates to numerical values
          aKey = this.$moment(aKey || '2000-01-01').format('x');
          bKey = this.$moment(bKey || '2000-01-01').format('x');
        }

        // For tags we order it by amount of tags
        if (this.sortBy.key === 'tags') {
          aKey = aKey.length;
          bKey = bKey.length;
        }

        //Compare numerical values
        let diff = aKey - bKey;

        if(this.sortBy.key === 'heat_index_raw') {
          if (aKey === null && bKey === null) {
            diff = 0;
          } else if (aKey === null) {
            return 1;
          } else if (bKey === null) {
            return -1;
          }
        }

        // For last seen/dim/tags we reverse the order
        if (['database_entry_time', 'daysInMilk', 'daysInInsemination'].includes(this.sortBy.key))
          diff *= -1;

        if (['building_name', 'bolus_name', 'eartag', 'breed'].includes(this.sortBy.key))
          if (this.sortBy.direction)
            diff = (bKey || '').localeCompare(aKey)
          else
            diff = (aKey || '').localeCompare(bKey)
        else
          // Numerical, check for direction
          if (this.sortBy.direction)
            diff *= -1;

        return diff;
      })
    },
    formatData(cows, sensor_logs, tags, highTempInfo) {
      return cows.map(cow => {
        const sensor_log = sensor_logs.find(({ cow_id }) => cow_id == cow.cow_id)
        const cow_tags = tags.filter(({ cows }) => cows.findIndex((tag_cow)=>tag_cow.cow_id == cow.cow_id) !== -1);
        const highTemp = highTempInfo.find(info => info.cow_id == cow.cow_id)
        return {
          ...cow,
          daysInMilk: cow.last_calving,
          daysInInsemination: cow.last_insemination,
          latest_sensor_log: sensor_log,
          tags: cow_tags,
          heat_index_raw: cow.heat_index,
          heat_index: UtilsService.formatPercentage(cow.heat_index),
          avg_48_h: highTemp ? highTemp.avg_48_h : null,
          highest_48_h: highTemp ? highTemp.highest_48_h : null
        }
      })
    },
    setSortBy(sortBy) {
      this.sortBy.direction =
        !this.sortBy.direction ? true : false;
      this.sortBy.key = sortBy;
    },
    setHeatReportProgress(value) {
      this.generateHeatReport.isInProgress = value;

      if (value === false) {
        this.selectAll = false;
        this.selected = [];
        this.generateHeatReport.cows = [];
        this.generateHeatReport.fromDate = null;
        this.generateHeatReport.toDate = null;
      }
    },
    heatReportHasSelectedCow() {
      if (this.generateHeatReport.cows.length === 0) {
        return true;
      }
      return false;
    },
    selectAllRows() {
      if (this.selectAll) {
        this.selected = this.cowList.map(cow => cow);
      } else {
        this.selected = [];
      }
    },
    setEditTagsProgress(value) {
      this.editTags.isInProgress = value;
      if (!value) {
        this.selected = [];
        this.editTags.selectedTags = [];
        this.fetchCows();
      }
    },
    async assign() {
      await this.assignTags({ cow_ids: this.generateHeatReport.cows.map(({ cow_id }) => cow_id), names: this.editTags.selectedTags })
      this.setEditTagsProgress(false);
      this.getTags();
    },
    async clear() {
      await this.clearTags({ cow_ids: [...new Set(this.generateHeatReport.cows.map(({ cow_id }) => cow_id))] });
      this.setEditTagsProgress(false);
    },
    toggleArchived() {
      this.showArchived = !this.showArchived;
    },
    prevPage() {
      if(this.page > 1)
        this.page--;
    },
    nextPage() {
      if(this.page < this.totalPages)
        this.page++;
    },
    showMore() {
      this.cowsPerPage += 100;
      this.page = 1;
      //this.updatePagination(this.cowList.length);
    },
    updatePagination(cows_length) {
      this.totalPages = Math.ceil(cows_length / this.cowsPerPage);
    }
  },
  watch: {
    selected() {
      this.generateHeatReport.cows = this.selected.map(cow => cow);
    }
  },
  computed: {
    modalData() {
      if (this.heatReportModalVisible) {
        return {
          reload: () => {
            this.fetchCows();
          },
          generateHeatReport: this.generateHeatReport
        }
      }
      return {
        reload: () => {
          this.fetchCows();
        }
      };
    },
    ...mapState({
      /**
       * The computed data for the table
       * @param {object} state The state object
       */
      cowList(state) {
        if (!state.cows.cows.length) return [];
        const cowList = state.cows.cows;
        const cowLists = [
          // Cow list
          cowList.filter(({ archived_at, deleted_at }) => !archived_at && !deleted_at),
        ];

        // Add archived cows if showArchived is true
        if (this.showArchived)
          cowLists.push(cowList.filter(({ archived_at }) => archived_at))

        // Format-search-sort for each list
        const finalCowList = cowLists.map((cList) => {
          const formattedData = this.formatData(cList, state.sensorLogs.latest, state.cows.tags, state.cows.highTempInfo);
          const searchedData = this.searchData(this.searchText, formattedData);
          return this.sortData(searchedData);
        }) // Concat lists
          .reduce((acc, val) => acc.concat(val), []);
          this.updatePagination(finalCowList.length);
        // Paginate
        const paginatedCows = finalCowList.slice((this.page - 1) * this.cowsPerPage, this.page * this.cowsPerPage);

        // Setting the cowList to all cows, we need this for the next cow functionality to work indendently of the pagination
        this.setCowList(finalCowList.map(({cow_id}) => ({cow_id})));
        return paginatedCows;
      },
      tagList(state) {
        return state.cows.tags.map(({ name }) => name);
      }
    })
  }
};



// WEBPACK FOOTER //
// ./src/components/_cows/cows.js